import moment from 'moment-timezone';

import { type CalendarEvent, type EventFormData, getTimeSlotUtcEffectiveDates } from '../data-utils';
import { trafficVariablesConfig } from '../traffic-variables-config';
import { dstManager } from './dst-manager';
import { getCalendarIntervals } from './generic';

const normalizeCreateData = ({ formData, timezone }: { formData: EventFormData; timezone: string }): EventFormData => {
	const { effectiveDates, ...restFormData } = formData;

	const normalizedEffectiveDates = getTimeSlotUtcEffectiveDates({
		start: effectiveDates[0],
		end: effectiveDates[1],
		timezone
	});

	// Add intervals in case of timeFrame === 'allDay' to unify form values output
	// DST related normalization in this case is taking effect if the current date in timezone is affected by DST
	let normalizedIntervals = getCalendarIntervals(formData, timezone);

	if (trafficVariablesConfig.enableHandleDST) {
		normalizedIntervals = [
			dstManager.adjustDateForServer(normalizedIntervals[0], timezone),
			dstManager.adjustDateForServer(normalizedIntervals[1], timezone)
		];
	}

	return {
		...restFormData,
		effectiveDates: [normalizedEffectiveDates.start, normalizedEffectiveDates.end],
		intervals: normalizedIntervals
	};
};

const normalizeUpdateData = ({
	formData,
	event,
	timezone
}: {
	formData: EventFormData;
	event: CalendarEvent;
	timezone: string;
}) => {
	let normalizedIntervals = getCalendarIntervals(formData, timezone, moment(event.start));

	if (trafficVariablesConfig.enableHandleDST) {
		normalizedIntervals = [
			dstManager.adjustDateForServer(normalizedIntervals[0], timezone),
			dstManager.adjustDateForServer(normalizedIntervals[1], timezone)
		];
	}

	return { ...formData, intervals: normalizedIntervals };
};

export const formDataManager = {
	normalizeCreateData,
	normalizeUpdateData
};
